import React from 'react';
import FormatValor from '../../../../Utils/formatCurrent';

import './styles.scss';

const ResumoTotais = ({ dadosAcrescimos }) => {
  const estilo = (value) => {
    if (value > 0) return { fontWeight: '900' };
  };

  return (
    <div className='centralized-space-evenly resumoTotais'>
      <span className='resumoTotais__item'>
        Total de juros:{' '}
        <span style={estilo(dadosAcrescimos.totalJuros)}>
          {FormatValor(dadosAcrescimos.totalJuros)}
        </span>
      </span>
      <span className='resumoTotais__item'>
        Total de multa:{' '}
        <span style={estilo(dadosAcrescimos.totalMulta)}>
          {FormatValor(dadosAcrescimos.totalMulta)}
        </span>
      </span>
      <span className='resumoTotais__item'>
        Total de acréscimos:{' '}
        <span style={estilo(dadosAcrescimos.totalAcrescimos)}>
          {FormatValor(dadosAcrescimos.totalAcrescimos)}
        </span>
      </span>
    </div>
  );
};

export default ResumoTotais;
